import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const NotificationsPage = lazy(() => import('./NotificationsPage'));

const routes: RouteObject[] = [{ path: '/notifications', element: <NotificationsPage /> }];
export default routes;
